import React from 'react';
import moment from 'moment-timezone';
import { ProviderNames } from 'models/Providers';
import CampaignHelper from 'helpers/CampaignHelper';

export const getCampaignId = (c) => {
    return c.campaign_id || c.campaign || c.campaign_name;
}

export const getCampaignName = (c) => {
    // default name to given, and try to find the name from the ID
    let name = c.campaign_name || c.campaign || c.campaign_id || c.name;
    // let id = c.campaign_id || c.campaign_name || c.campaign || c.id;
    // let campaign = CampaignHelper.lookForCampaign(id, c.provider || ProviderNames.FACEBOOK);
    // if (campaign) name = campaign.name;
    return name.replace(' ', '&nbsp;');
}

export const getCampaignKey = (c) => {
    return `${getCampaignId(c) + getCampaignName(c)}`;
}

export const getAdsetId = (a) => {
    return (a.adset_id || a.adset || a.adset_name);
}

export const getAdsetName = (c) => {
    // default name to given, and try to find the name from the ID
    let name = c.adset_name || c.adset || c.adset_id;
    let id = c.adset_id || c.adset_name || c.adset;
    let adset = CampaignHelper.lookForAdset(id, c.provider || ProviderNames.FACEBOOK);
    if (adset) name = adset.name;
    return name.replace(' ', '&nbsp;');
}

export const getAdsetKey = (a) => {
    return `${getAdsetId(a) + getAdsetName(a)}`;
}

export const getAdId = (a) => {
    return (a.ad_id || a.ad || a.ad_name).replace(' ', '&nbsp;');
}

export const getAdName = (c) => {
    // default name to given, and try to find the name from the ID
    let name = c.ad_name || c.ad || c.ad_id;
    let id = c.ad_id || c.ad_name || c.ad;
    let ad = CampaignHelper.lookForAd(id, c.provider || ProviderNames.FACEBOOK);
    if (ad) name = ad.name;
    return name.replace(' ', '&nbsp;');
}

export const getAdKey = (a) => {
    return `${getAdId(a) + getAdName(a)}`;
}

export const renderName = (nameStr) => {
    return (<span className="caa-name-html" dangerouslySetInnerHTML={{ __html: `${nameStr ? nameStr : '(Unknown)'}` }}></span>);
}

export const getAllCampaignsFromEvents = (data) => {
    type StringArray = Array<string>
    let result: StringArray = []
    data.forEach((c) => {
        if (c.utm_campaign && !result.find((campaign) => campaign === c.utm_campaign)) {
            result.push(c)
        }
    })
    return result
}

export const findCampaignAdset = (selectedAdset, selectedCampaignIDs, campaigns) => {
    let campaign = undefined, adset = undefined;
    let filteredCampaigns = campaigns.filter(c => selectedCampaignIDs.includes(c.campaign_id) || selectedCampaignIDs.includes(c.campaign) || selectedCampaignIDs.includes(c.campaign_name));

    campaigns = filteredCampaigns.forEach(c => {
        if (c.adsets) {
            c.adsets.forEach(_adset => {
                if (_adset == selectedAdset || _adset == selectedAdset || _adset == selectedAdset) {
                    campaign = c;
                    adset = _adset;
                    return;
                }
            });
        }
    });

    return { campaign, adset };
};

export const getProviderNameFromUtmSource = (utmSource) => {
    switch (utmSource.toLowerCase()) {
        case "ig":
        case "instagram":
            // we return FB as the IG provider so it looks up by the FB campaigns.
            return ProviderNames.FACEBOOK;
        case "fb":
        case "facebook":
            return ProviderNames.FACEBOOK;
        case "google":
            return ProviderNames.GOOGLE;
        case "klaviyo":
            return ProviderNames.KLAVIYO;
        case "shopify":
            return ProviderNames.SHOPIFY;
        case "amazon":
            return ProviderNames.AMAZON;
        case "tiktok":
            return ProviderNames.TIKTOK;
        default:
            return undefined;
    }
}
